module.exports = __webpack_public_path__ + "static/oravro-logo2-9843f7c9ee8f3c30adca0d9622e36097.png";